import {
    Dialog,
    DialogTitle,
    List,
    ListItemButton,
    ListItemText,
    ListItemIcon,
    Divider,
} from "@mui/material";
import {
    Add,
    ViewColumn,
    Save,
    Refresh,
} from "@mui/icons-material";
import { useKanban } from "./kanban-provider";


export default function KanbanCommandPalette({ open, onClose }) {
    const {
        openCreateTask,
        openCreateColumn,
        saveData,
        loadData,
    } = useKanban();

    const run = async (fn) => {
        onClose();
        await fn();
    };


    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle
                sx={{
                    borderBottom: "1px solid",
                    borderColor: "neutral.deep",
                }}
            >
                Command Palette
            </DialogTitle>

            <List>
                <ListItemButton onClick={() => run(openCreateTask)}>
                    <ListItemIcon>
                        <Add />
                    </ListItemIcon>
                    <ListItemText primary="Create Task" secondary="Add a new task" />
                </ListItemButton>

                <ListItemButton onClick={() => run(openCreateColumn)}>
                    <ListItemIcon>
                        <ViewColumn />
                    </ListItemIcon>
                    <ListItemText primary="Create Column" secondary="Add a new column" />
                </ListItemButton>

                <Divider />

                <ListItemButton onClick={() => run(saveData)}>
                    <ListItemIcon>
                        <Save />
                    </ListItemIcon>
                    <ListItemText primary="Save Board" secondary="Persist board state" />
                </ListItemButton>

                <ListItemButton onClick={() => run(loadData)}>
                    <ListItemIcon>
                        <Refresh />
                    </ListItemIcon>
                    <ListItemText primary="Reload Board" secondary="Reload from server" />
                </ListItemButton>
            </List>
        </Dialog>
    );
}
